export const QUERY_SEARCH_TAX_FORM_ROWS = "QUERY_SEARCH_TAX_FORM_ROWS";
export const QUERY_SEARCH_TAX_FORM_ROWS_COUNT =
  "QUERY_SEARCH_TAX_FORM_ROWS_COUNT";
